import { render, staticRenderFns } from "./SchoolFormModal.vue?vue&type=template&id=ea6f42c4&scoped=true"
import script from "./SchoolFormModal.vue?vue&type=script&lang=js"
export * from "./SchoolFormModal.vue?vue&type=script&lang=js"
import style0 from "./SchoolFormModal.vue?vue&type=style&index=0&id=ea6f42c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6f42c4",
  null
  
)

export default component.exports